import { render, staticRenderFns } from "./sSelectTurn.vue?vue&type=template&id=95ddd3f8"
import script from "./sSelectTurn.vue?vue&type=script&lang=js"
export * from "./sSelectTurn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports